import React from 'react';
import NavBar2 from '../Shared/NavBar2/NavBar2';
import { Card, Col, Row } from "react-bootstrap";
import Footer from '../Shared/Footer/Footer';
const teams = [
    {
        img: "https://i.ibb.co/0FhgCw9/c1.jpg",
        name: "Jasmin Bartlett",
        position: "Chef",
        desc: "Lorem ipsum dolor sit amet da, consectet adipiscing elit diam"
    },
    {
        img: "https://i.ibb.co/HrQQc3N/c2.jpg",
        name: "Mya Mullins",
        position: "Cookie Maker",
        desc: "Lorem ipsum dolor sit amet da, consectet adipiscing elit diam"
    },
    {
        img: "https://i.ibb.co/KDRpCLV/c3.jpg",
        name: "Julius Hale",
        position: "Pastry Cook",
        desc: "Lorem ipsum dolor sit amet da, consectet adipiscing elit diam"
    },
    {
        img: "https://i.ibb.co/BNpHfg3/c4.jpg",
        name: "Ashton Bird",
        position: "Chef",
        desc: "Lorem ipsum dolor sit amet da, consectet adipiscing elit diam"
    },
    {
        img: "https://i.ibb.co/p4n9Fxv/c5.jpg",
        name: "Will Richard",
        position: "Cake Maker",
        desc: "Lorem ipsum dolor sit amet da, consectet adipiscing elit diam"
    },
    {
        img: "https://i.ibb.co/h1t1tPH/c6.jpg",
        name: "Rylee Mclean",
        position: "Chef",
        desc: "Lorem ipsum dolor sit amet da, consectet adipiscing elit diam"
    },
    {
        img: "https://i.ibb.co/Tb7P9GD/c7.jpg",
        name: "Sonny Hickman",
        position: "Cake Maker",
        desc: "Lorem ipsum dolor sit amet da, consectet adipiscing elit diam"
    },
    {
        img: "https://i.ibb.co/QdXqkVJ/c8.jpg",
        name: "Marvin Cook",
        position: "Chef",
        desc: "Lorem ipsum dolor sit amet da, consectet adipiscing elit diam"
    },

]
const OurTeam = () => {
    return (
        <div>
            <NavBar2 />
            <div className="wwd margin">
                <div className="about1">
                    <h1 className="text-dark mt-5">Our Team</h1>
                    <p>Etiam convallis, felis quis dapibus dictum, libero mauris luctus <br /> nunc, non fringilla purus ligula non justo. Non fringilla purus.</p>
                </div>
            </div>
            {/* our teams card */}
            <div className="container-fluid">
                <Row lg={4}>
                    {
                        teams.map(team => (
                            <Col sm={12} className="mb-5 text-center">
                                <Card style={{ height: "420px", border: "0px",width:"250px" }}>
                                    <Card.Img variant="top" style={{ height: "300px" }} src={team.img} />
                                    <Card.Body className="mx-auto" style={{width:"250px"}}>
                                        <Card.Title>
                                            {team.name}
                                        </Card.Title>
                                        <p style={{color:"#CBAC64",fontWeight:"bold"}}>
                                            {team.position}
                                        </p>
                                        <small style={{width:"50px"}}>
                                            {team.desc}
                                        </small>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))
                    }
                </Row>
            </div>
            <Footer/>
        </div>
    );
};

export default OurTeam;